RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.LandscapeSettings = window.createMarionetteApp();
    app.name = 'LandscapeSettings';

    app.addRegions({
        general: '#general',
        email: '#emailTab',
        branding: '.x-customize-branding',
        facebookAdAccounts: '.x-facebook-ad-accounts'
    });

    app.on('start', function () {
        Backbone.history.start({
            root: '/settings'
        });
    });

});
